import { render, staticRenderFns } from "./operations.vue?vue&type=template&id=0875b5fb&scoped=true"
import script from "./operations.vue?vue&type=script&lang=ts"
export * from "./operations.vue?vue&type=script&lang=ts"
import style0 from "./operations.vue?vue&type=style&index=0&id=0875b5fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875b5fb",
  null
  
)

export default component.exports